// extracted by mini-css-extract-plugin
export default {"tabContent":"V97s8K6LkX","tabContent_constrainWidth":"J1sb_kzRmf"};